import qs from 'query-string';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const useModeSwitch = () => {
	const { search } = useLocation();

	const [selectedMode, setSelectedMode] = useState('ON');

	const changeMode = (mode: string) => setSelectedMode(mode);

	const switchParams = () => {
		if (!search) return;
		const params: { mode?: string } = qs.parse(search);
		if (!params || !params.mode) return;
		setSelectedMode(params.mode);
	};

	useEffect(switchParams, [search]);

	return {
		selectedMode,
		changeMode,
	};
};

export const useModeParams = () => {
	const { code } = useParams<{ code: string }>();
	const navigate = useNavigate();
	const changeModeParam = (mode: string) => navigate(`/coaches/${code}?mode=${mode}`);

	return {
		changeModeParam,
	};
};
